import React from 'react';
import { stripePaymentSuccess } from "../../../data/loca/stripe";
import { useLoaderData } from "react-router-dom";

export async function loader() {

    let params = new URLSearchParams(document.location.search);
    let payment_intent = params.get("payment_intent"); 
    let payment_intent_client_secret = params.get("payment_intent_client_secret"); 
    let resp = await stripePaymentSuccess(payment_intent, payment_intent_client_secret);
    return { response: resp };
}

export default function StripeDepositSuccess() {
    const { response } = useLoaderData();
    const requiresElectronicSignature = response?.requiresElectronicSignature ?? response?.RequiresElectronicSignature;

    return (
         <div>
            <div id="thumbnail">


                <div className="depositSuccess">

                    <h2>Le paiement a été effectué avec succès ! Le loueur en a été informé.</h2>
                    {requiresElectronicSignature && (
                        <p>Signature électronique nécessaire pour finaliser la location.</p>
                    )}
                 
                    <i className="pi pi-check-circle" style={{ fontSize: '3rem' }}></i>
                </div>
                

            </div>

        </div>
        
    )            
}
